import { render, staticRenderFns } from "./opinionText.vue?vue&type=template&id=4fa673fd&scoped=true&"
import script from "./opinionText.vue?vue&type=script&lang=js&"
export * from "./opinionText.vue?vue&type=script&lang=js&"
import style0 from "./opinionText.vue?vue&type=style&index=0&id=4fa673fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa673fd",
  null
  
)

export default component.exports